<div class="ct" [class]="typeClass">
  <i [class]="'ct-icon ti ' + icon"></i>

  <div class="ct-body">
    <p class="ct-title">{{ label }}</p>
    <p class="ct-message" [innerHTML]="message"></p>
  </div>

  <button class="ct-close" (click)="remove()" type="button" aria-label="Dismiss">
    <i class="ti ti-close"></i>
  </button>

  <div class="ct-progress" *ngIf="options.progressBar">
    <div class="ct-progress-bar" [style.width]="width + '%'"></div>
  </div>
</div>
